// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { PortalBaseEntity } from '../portal-base-entity';
import { Job } from './job';
import { Practice } from './practice';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class BankAccount extends PortalBaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  accountName?: string;
  accountNumber?: string;
  bankCode?: string;
  bankId!: number;
  bsb?: string;
  createdAt!: Date;
  createdBy!: string;
  currentStatus?: string;
  deleted!: boolean;
  isActive!: boolean;
  jobId?: number;
  practiceId!: number;
  sourceJson?: string;
  uid!: string;
  updatedAt!: Date;
  updatedBy!: string;
  version!: any;
  job!: Job;
  practice!: Practice;
}

